import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";

// Set the default color for the avatar background
const blueColor = "#007bff";

function stringAvatar(name = "John Doe") {
  const nameParts = name.trim().split(" ").filter(Boolean); // clean up extra spaces

  let initials = "";
  if (nameParts.length === 1) {
    initials = `${nameParts[0][0]}`;
  } else if (nameParts.length === 2) {
    initials = `${nameParts[0][0]}${nameParts[1][0]}`;
  } else {
    initials = `${nameParts[0][0]}${nameParts[2][0]}`;
  }

  return {
    sx: {
      bgcolor: "var(--primary-color)",
    },
    children: initials.toUpperCase(), // ✅ Force uppercase
  };
}

export default function BackgroundLetterAvatars({ name }) {
  // Use a default name if 'name' is not provided or is an empty string
  const displayName = name && name.trim() ? name : "Default Name";

  return (
    <Stack direction="row" spacing={2}>
      <Avatar {...stringAvatar(displayName)} />
    </Stack>
  );
}
